import React from 'react'
import PropTypes from 'prop-types'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import ContentfulButtonV3 from '../Utilities/Buttons/V3/ContentfulButtonV3'
import FacebookButton from '../../assets/images/logos/FacebookButton.svg'
import TwitterButton from '../../assets/images/logos/TwitterButton.svg'
import InstagramButton from '../../assets/images/logos/InstagramButton.svg'
import LinkedinButton from '../../assets/images/logos/LinkedinButton.svg'
import { blogBodyOptions } from '../Utilities/DocumentToReactOptions'

function BlogPostContent({ data }) {
  const { postBody } = data
  let CTAComp
  if (data?.cta) {
    CTAComp = (
      <div className="blog-post--cta-container">
        {data.cta.map(button => {
          return <ContentfulButtonV3 key={button.text} data={button} />
        })}
      </div>
    )
  }
  let blogBody
  if (postBody) {
    const options = blogBodyOptions()
    blogBody = renderRichText(postBody, options)
  }
  const SocialMediaButtons = [
    {
      imgAltText: 'Facebook Button',
      image: {
        sizes: {
          srcSet: FacebookButton,
          src: FacebookButton
        }
      },
      url: 'https://www.facebook.com/avantforward'
    },
    {
      imgAltText: 'Twitter Button',
      image: {
        sizes: {
          srcSet: TwitterButton,
          src: TwitterButton
        }
      },
      url: 'https://twitter.com/avant_forward'
    },
    {
      imgAltText: 'Instagram Button',
      image: {
        sizes: {
          srcSet: InstagramButton,
          src: InstagramButton
        }
      },
      url: 'https://www.instagram.com/avantforward/?igshid=NWRhNmQxMjQ='
    },
    {
      imgAltText: 'Linkedin Button',
      image: {
        sizes: {
          srcSet: LinkedinButton,
          src: LinkedinButton
        }
      },
      url: 'https://www.linkedin.com/company/avant-us/'
    }
  ]

  const SocialMediaComp = (
    <div className="blog-post--social-media-container">
      {SocialMediaButtons.map((button, index) => {
        const key = index + 1
        const img = (
          <img
            className="blog-post__logo"
            srcSet={button.image.sizes.srcSet}
            src={button.image.sizes.src}
            alt={button.imageAltText}
          />
        )
        return (
          <a
            className="blog-post__button"
            href={button.url}
            target="_blank"
            rel="noopener noreferrer"
            key={key}
          >
            {img}
          </a>
        )
      })}
    </div>
  )
  return (
    <div className="blog-post--content">
      <h2 className="blog-post--headline">{data.headline}</h2>
      <div className="blog-post--body">{blogBody}</div>
      <div className="blog-post--buttons-container">
        {CTAComp}
        {SocialMediaComp}
      </div>
    </div>
  )
}

BlogPostContent.propTypes = {
  data: PropTypes.object.isRequired
}

export default BlogPostContent
